import React, { useState } from "react";
import { ReactComponent as DeleteArtistIcon } from "../../../../public/delete-artist.svg";
import MusicGenres from "../../shared/MusicGenres";

export default props => {
  let [artists, setArtists] = useState(props.user.artist_interests || []);
  const addNewArtist = e => {
    let artistInput = document.getElementById("artistInterestName");
    let newArtist = artistInput.value;
    if (artists.includes(newArtist) || newArtist === "" || artists.length >= 10)
      return;
    artistInput.value = "";
    setArtists([...artists, newArtist]);
  };
  const handleRemoveArtist = e => {
    let artistArr = artists;
    let filterdArr = artistArr.filter(artist => {
      return artist !== e.currentTarget.value;
    });
    setArtists(filterdArr);
  };
  const handleArtistEnterPress = e => {
    if (e.keyCode === 13) {
      addNewArtist();
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return (
    <>
      <div id="music_interest" className="form-row pb-3">
        <div className="col-100 d-flex align-items-center pt-5">
          <label className="m-0 my-4">Genres I Like</label>
        </div>
        <div className="col-100">
          <MusicGenres
            defaultChecked={
              props.user.music_interests &&
              props.user.music_interests.map((a) => a.toLowerCase())
            }
            name="music_interests[]"
            onChange={() => {}}
          />
        </div>
      </div>
      <div id="artists_interest" className="form-row">
        <div className="col-100">
          <label className="m-0">Artists I Like</label>
        </div>
        <div className="col-100 added-artists my-4">
          {artists.map((artist, indx) => (
            <span
              className="badge badge-pill badge-dark py-2 mr-2 text-uppercase px-3"
              key={artist + indx}
            >
              <input
                value={artist}
                className="sr-only"
                name={`artist_interests[]`}
              />
              <span className="position-relative artist-text"> {artist}</span>
              <button
                type="button"
                className="border-0 bg-transparent p-0 position-relative"
                value={artist}
                onClick={handleRemoveArtist}
              >
                <DeleteArtistIcon />
              </button>
            </span>
          ))}
        </div>
        <div className="col-100 d-flex artist-name">
          <input
            className="form-control"
            placeholder="Artist name"
            id="artistInterestName"
            onKeyDown={handleArtistEnterPress}
          />
          <button
            type="button"
            className="btn btn-sm btn-primary btn-add"
            onClick={addNewArtist}
          >
            Add
          </button>
        </div>
      </div>
    </>
  );
};
